export default {"src":"/_next/static/media/LegacyIncompleteIcon.160d49d6.svg","height":19,"width":23,"blurWidth":0,"blurHeight":0};